import { jsxs, jsx } from "react/jsx-runtime";
import { Grid, styled } from "@mui/material";
import brandclub_colors from "../../../colors/brandclubColors.js";
import { formatMoney } from "../../../utils/stringUtils.js";
const Container = styled("div")({
  width: 340,
  marginLeft: "auto",
  marginRight: "auto",
  ".row": {
    display: "flex",
    justifyContent: "space-between",
    padding: "7.5px 0",
    ":nth-last-of-type(2)": {
      paddingBottom: 20
    }
  },
  ".total-row": {
    fontWeight: 600,
    borderTop: `1px solid ${brandclub_colors.blueWhiteBorder}`,
    padding: "20px 0 15px"
  }
});
const RewardTable = ({ rows, containerStyle = {} }) => {
  const totalRewards = rows.reduce((acc, [, amount]) => acc + amount, 0);
  return /* @__PURE__ */ jsxs(Container, { style: containerStyle, children: [
    rows.map((row, index) => /* @__PURE__ */ jsxs(Grid, { container: true, className: "row", children: [
      /* @__PURE__ */ jsx(Grid, { item: true, children: row[0] }),
      /* @__PURE__ */ jsx(Grid, { item: true, children: formatMoney(row[1]) })
    ] }, index)),
    /* @__PURE__ */ jsxs(Grid, { container: true, className: "row total-row", children: [
      /* @__PURE__ */ jsx(Grid, { item: true, children: "Total rewards" }),
      /* @__PURE__ */ jsx(Grid, { item: true, children: formatMoney(totalRewards) })
    ] })
  ] });
};
export {
  RewardTable
};
//# sourceMappingURL=RewardTable.js.map
